import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { alertDialog } from '@/ui_v3';

import { editingQuizIdAtom } from '../components/focus/editModeAtom';
import { focusField } from '../components/focus/focusUtils';
import { useBuildFormContext } from '../form/schema';
import {
  AT_LEAST_ONE_QUIZ_REQUIRED_MESSAGE,
  BuildQuizListFormSchema,
  validateQuizList,
} from '../form/schema/BuildQuizListSchema';

export const useValidateQuizList = () => {
  const setEditId = useSetAtom(editingQuizIdAtom);
  const { t } = useTranslation(['build']);

  const { getValues } = useBuildFormContext();

  const validate = async () => {
    const formData = getValues();

    const { success: quizListSuccess, error: quizListError } =
      BuildQuizListFormSchema.safeParse(formData);

    //먼저 퀴즈가 비어있는지 확인
    const isQuizEmpty =
      !quizListSuccess &&
      quizListError.errors.some(
        error => error.message === AT_LEAST_ONE_QUIZ_REQUIRED_MESSAGE,
      );

    if (isQuizEmpty) {
      await alertDialog.openAsync({
        header: {
          title: t('build:build.alert.noQuiz'),
        },
      });
      return false;
    }
    const { success, error } = validateQuizList(formData.quizList);

    if (!success) {
      await alertDialog.openAsync({
        header: {
          title: t('build:build.quiz.invalid'),
        },
      });

      const targetIndex = Number(error?.errors[0]?.path[0] ?? 0);

      const targetQuizId = formData.quizList[targetIndex]?.id;

      setEditId(targetQuizId);

      focusField(`quizList.${error?.errors[0]?.path.join('.')}`, {
        delay: 100,
        scroll: true,
        focus: true,
      });

      return false;
    }
    return true;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(validate, [getValues]);
};
